import {
  ApolloClient,
  InMemoryCache,
  createHttpLink,
  from,
  onError,
} from "@xatom/apollo-graphql";
import { GQL_ENDPOINT } from "../config";

const publicHttpLink = createHttpLink({
  credentials: "include",
  uri: GQL_ENDPOINT,
});

const onPublicError = onError(
  ({ graphQLErrors, forward, operation }) => {
    for (let err of graphQLErrors) {
      console.log(err);
      if (err.message === "Authentication failed") {
        //handle the error
        console.log("handle public error");
      }
    }
    return forward(operation);
  }
);

export const publicClient = new ApolloClient({
  link: from([onPublicError, publicHttpLink]),
  cache: new InMemoryCache(),
});
